import { ChevronDown } from 'lucide-react';
import React from 'react';
import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger
} from '@components/ui/collapsible';
import { I18n } from '../../../core/i18n';
import { injectTSDI } from '../../../core/tsdi';
import { ReactComponent as Step } from '../../../../assets/svg/icons/steps.svg';
import { ReactComponent as Studio } from '../../../../assets/svg/icons/target.svg';
import { ReactComponent as Workout } from '../../../../assets/svg/icons/workout.svg';
import { ActivityPointsDetails } from './activity-points-details';
import { ActivityPointsDto } from '../../../core/api/FitnessActivityClient';

interface ActivityPointsProps {
    activityPoints: ActivityPointsDto;
}

function getIconType(activityType: ActivityPointsDto['activityType']) {
    switch (activityType) {
        case 'DAILY_STEPS':
            return { icon: Step, viewBox: '0 0 13 22' };
        case 'FACILITY_VISIT':
            return { icon: Studio, viewBox: '0 0 22 22' };
        default:
            return { icon: Workout, viewBox: '0 0 20 20' };
    }
}

export const ActivityPoints = ({ activityPoints }: ActivityPointsProps) => {
    const { formatDateTime } = injectTSDI(I18n);
    const { icon: Icon, viewBox } = getIconType(activityPoints.activityType);
    const [expanded, setExpanded] = React.useState<boolean>(false);
    return (
        <Collapsible asChild open={expanded} onOpenChange={setExpanded}>
            <li>
                <CollapsibleTrigger className="flex w-full items-center gap-4 px-4 py-4 text-left text-sm hover:bg-accent/50 [&[data-state=open]>svg]:rotate-180">
                    <span className="w-52 shrink-0 whitespace-nowrap tabular-nums">
                        {formatDateTime(activityPoints.timestamp)}
                    </span>
                    <span className="flex min-w-0 flex-1 items-center gap-3 text-muted-foreground">
                        <Icon
                            viewBox={viewBox}
                            className="size-5 shrink-0 fill-current"
                        />
                        <span className="truncate">
                            {activityPoints.activityType}
                        </span>
                    </span>
                    <span className="shrink-0 tabular-nums">
                        <span className="text-base font-semibold">
                            {activityPoints.value}
                        </span>{' '}
                        <span className="text-xs text-muted-foreground">
                            pts
                        </span>
                    </span>
                    <ChevronDown className="size-4 shrink-0 text-muted-foreground transition-transform" />
                </CollapsibleTrigger>
                <CollapsibleContent className="border-t bg-muted/20 px-4 pt-4 pb-4">
                    {activityPoints && activityPoints.id && expanded && (
                        <ActivityPointsDetails
                            activityPoints={activityPoints}
                        />
                    )}
                </CollapsibleContent>
            </li>
        </Collapsible>
    );
};
